import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import Button from "../../../../../components/Button";
import { FieldArray } from "react-final-form-arrays";
import { Field, useForm } from "react-final-form";
import BootstrapInput from "../../../../../components/BootstrapInput";
import { ShowCurrency } from "./ShowCurrency";
import InfoIcon from "../../../../../components/InfoIcon";

const useStyles = makeStyles(() => ({
  label: {
    marginTop: 8,
    marginBottom: 16,
    fontSize: 18,
    fontWeight: "bold",
    color: "#535358",
  },
  otherFeesLabel: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#535358",
    marginTop: 18,
  },
  buttonContainer: {
    textAlign: "right",
    marginTop: 12,
  },
  button: {
    fontSize: 17,
    fontWeight: "bold",
    height: 44,
    color: "#fefefe",
    backgroundColor: "#7ec884",
    width: 195,
    padding: "0 10px!important",
  },
  fieldArrayContainer: {
    display: "flex",
    flexDirection: "column-reverse",
  },
  elementContainer: {
    marginTop: 16,
  },
  element: {
    display: "inline-block",
    width: "33%",
    paddingRight: 12,
    marginTop: 16,
  },
}));

const OtherFees = ({ name, infoIcon = "" }) => {
  const classes = useStyles();
  const {
    mutators: { push },
  } = useForm();

  return (
    <div>
      <div className={classes.label}>
        Other Fees
        {infoIcon && <InfoIcon text={infoIcon} portalMode={false} />}
      </div>
      <div className={classes.buttonContainer}>
        <Button
          color={"success"}
          fullWidth
          onClick={() => push(`${name}.addedOtherFees`, undefined)}
          variant="contained"
          className={classes.button}
        >
          Add Other Fees
        </Button>
      </div>
      <div className={classes.fieldArrayContainer}>
        <FieldArray name={`${name}.addedOtherFees`}>
          {({ fields }) =>
            fields.map((name) => (
              <div key={name} className={classes.elementContainer}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={4}>
                    <Field
                      fullWidth
                      type="text"
                      label="Other Fee"
                      placeholder="Name of other fee"
                      name={`${name}.name`}
                      component={BootstrapInput}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <Field
                      fullWidth
                      type="text"
                      label="Amount"
                      placeholder="Amount"
                      name={`${name}.amount`}
                      component={BootstrapInput}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <ShowCurrency />
                  </Grid>
                </Grid>
              </div>
            ))
          }
        </FieldArray>
      </div>

      <div className={classes.elementContainer}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={4}>
            <Field
              fullWidth
              type="text"
              label="Other Fee"
              placeholder="Name of other fee"
              name={`${name}.mainOtherFees.0.name`}
              component={BootstrapInput}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Field
              fullWidth
              type="text"
              label="Amount"
              placeholder="Amount"
              name={`${name}.mainOtherFees.0.amount`}
              component={BootstrapInput}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <ShowCurrency />
          </Grid>
        </Grid>
      </div>

      <div className={classes.elementContainer}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={4}>
            <Field
              fullWidth
              type="text"
              label="Other Fee"
              placeholder="Name of other fee"
              name={`${name}.mainOtherFees.1.name`}
              component={BootstrapInput}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Field
              fullWidth
              type="text"
              label="Amount"
              placeholder="Amount"
              name={`${name}.mainOtherFees.1.amount`}
              component={BootstrapInput}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <ShowCurrency />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default OtherFees;
